module.exports = __webpack_public_path__ + "img/home-dfh.ac51e1cb.svg";